
export const ADMIN_UID = 'SqaEjqqeJEcP8nJnFevzXhUhEjd2'; 
